import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { addContact, editContact } from "../../redux/services/contactSlice";
import { ROUTES } from "../../constant";

const ContactFormPage = ({ action }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const contactId = queryParams.get("contactId");
  const [loading, setLoading] = useState(false);

  const initialValues = {
    name: "",
    email: "",
    phone: "",
    website: "",
    company: "",
    message: "",
  };

  const validationSchema = Yup.object({
    name: Yup.string().required("Name is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
    phone: Yup.string().required("Phone is required"),
    website: Yup.string().nullable(),
    company: Yup.string().required("Company is required"),
    message: Yup.string().required("Message is required"),
  });

  const onSubmit = async (values) => {
    setLoading(true);
    try {
      let payload = { ...values };
      if (contactId) {
        payload.contactUsId = contactId;
      }
      let response;
      if (contactId) {
        response = await dispatch(editContact(payload));
      } else {
        response = await dispatch(addContact(payload));
      }
      if (response?.payload?.status === 200) {
        toast.success(response?.payload?.message, {
          autoClose: 2000,
          pauseOnHover: false,
        });
        navigate(ROUTES.WEBSITE.CONTACT_ENQUIRIES);
        resetForm();
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    setValues,
    resetForm,
  } = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
  });

  useEffect(() => {
    if (contactId && location.state?.row) {
      const row = location.state.row;
      setValues({
        name: row?.name || "",
        email: row?.email || "",
        phone: row?.phone || "",
        website: row?.website || "",
        company: row?.company || "",
        message: row?.message || "",
      });
    }
  }, [contactId, location.state, setValues]);

  return (
    <div>
      <div className="bg-background py-4 sm:py-4">
        <div className="px-4 md:py-10 py-5 bg-card shadow rounded-3xl sm:p-10">
          <p className="md:text-3xl text-xl text-center font-medium uppercase text-primary">
            {action} Contact
          </p>
          <form className="mt-6" onSubmit={handleSubmit}>
            <div className="grid md:grid-cols-2 grid-cols-1 gap-5">
              <div>
                <label className="text-sm font-medium text-foreground">Name</label>
                <input
                  type="text"
                  name="name"
                  className="w-full px-4 py-2 border border-border rounded-xl bg-card"
                  value={values.name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Name"
                />
                {touched.name && errors.name && (
                  <div className="text-red-500 text-sm">{errors.name}</div>
                )}
              </div>

              <div>
                <label className="text-sm font-medium text-foreground">Email</label>
                <input
                  type="email"
                  name="email"
                  className="w-full px-4 py-2 border border-border rounded-xl bg-card"
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Email"
                />
                {touched.email && errors.email && (
                  <div className="text-red-500 text-sm">{errors.email}</div>
                )}
              </div>

              <div>
                <label className="text-sm font-medium text-foreground">Phone</label>
                <input
                  type="text"
                  name="phone"
                  className="w-full px-4 py-2 border border-border rounded-xl bg-card"
                  value={values.phone}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Phone"
                />
                {touched.phone && errors.phone && (
                  <div className="text-red-500 text-sm">{errors.phone}</div>
                )}
              </div>

              <div>
                <label className="text-sm font-medium text-foreground">Website</label>
                <input
                  type="text"
                  name="website"
                  className="w-full px-4 py-2 border border-border rounded-xl bg-card"
                  value={values.website}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Website"
                />
                {touched.website && errors.website && (
                  <div className="text-red-500 text-sm">{errors.website}</div>
                )}
              </div>

              <div>
                <label className="text-sm font-medium text-foreground">Company</label>
                <input
                  type="text"
                  name="company"
                  className="w-full px-4 py-2 border border-border rounded-xl bg-card"
                  value={values.company}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Company"
                />
                {touched.company && errors.company && (
                  <div className="text-red-500 text-sm">{errors.company}</div>
                )}
              </div>

              <div className="md:col-span-2">
                <label className="text-sm font-medium text-foreground">Message</label>
                <textarea
                  name="message"
                  rows={5}
                  className="w-full px-4 py-2 border border-border rounded-xl bg-card"
                  value={values.message}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Message"
                />
                {touched.message && errors.message && (
                  <div className="text-red-500 text-sm">{errors.message}</div>
                )}
              </div>
            </div>
            <div className="flex justify-center">
              <button
                type="submit"
                className="w-full sm:w-[250px] min-h-[50px] flex justify-center items-center text-white bg-primary text-lg font-semibold rounded-xl hover:bg-accent mt-7"
              >
                {loading ? <div className="loader"></div> : "Save"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactFormPage;


